import { SummaryType } from '../../store/research/types';

export const summaryConfig: Partial<
  Record<
    SummaryType,
    {
      heading: string;
      order: number;
    }
  >
> = {
  biz_description: {
    heading: 'Business Description',
    order: 1,
  },
  competitors: {
    heading: 'Customers and Competitors',
    order: 2,
  },
  investment_thesis: {
    heading: 'Investment Thesis',
    order: 3,
  },
  risks: {
    heading: 'Risks',
    order: 4,
  },
};

export const orderedSummaryTypes = Object.keys(summaryConfig).sort(
  (a, b) =>
    (summaryConfig[a as SummaryType]?.order ?? 0) - (summaryConfig[b as SummaryType]?.order ?? 0),
) as SummaryType[];
